import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  CustomTextField,
  CustomDateTimePicker,
  CustomSelect
} from '../../../components/CustomDisabledFields'
import { Typography, withStyles } from '@material-ui/core'
import CustomFileViewer from '../../../components/CustomFileViewer'
import MunicipioAutocomplete from '../../Municipio/MunicipioAutocomplete'
import { estadosOptions } from '../../Municipio/estados'
import Select from '../../../components/Select'
import { parseCep, parseCpf, parsePlaca, parseTelefone } from '../../../utils/Parse'
import ObservacaoField from '../../../components/ObservacaoField'
import GerenciadoraField from '../Fields/GerenciadoraField'
import { CustomAutocomplete } from '../../../components'
import { AuthContext, Checkbox } from 'elentari'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'
import { TarefaStatusEnum } from '../TarefaStatus'
import EntregasFields from './EntregasFields'
import MercadoriaAutocomplete from '../../Mercadorias/MercadoriaAutocomplete'
import NumberFormatCustom from '../../../components/NumberFormatCustom'
import CentroCustoAutocomplete from '../../CentrosCusto/CentroCustoAutocomplete'

const styles = theme => ({
  marginTop: {
    marginTop: theme.spacing(5)
  }
})

const Prioridade = {
  Baixa: 1,
  Normal: 2,
  Alta: 3,
  Urgente: 4
}

const MonitoramentoForm = ({
  form,
  values,
  cannotUpdate,
  showError,
  isNew
}) => {
  const { user } = useContext(AuthContext)
  const canEdit = user.realm === 'admin'
  const canEditStatus = user.realm === 'admin' || user.realm === 'analista_op_2'

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Solicitação de Monitoramento
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          hideEmpty
          disabled={!canEdit || cannotUpdate}
          component={CustomAutocomplete}
          options={Object.keys(Prioridade).map(key => ({
            value: Prioridade[key],
            label: key
          }))}
          label="Prioridade"
          name="prioridade"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          disabled={!canEditStatus || cannotUpdate}
          component={UsuarioAutocomplete}
          realm="analistaOpAdmin"
          label="Responsável"
          name="responsavelId"
        />
      </Grid>
      {canEditStatus && !cannotUpdate ? (
        <Grid item xs={12} sm={3}>
          <Field
            fullWidth
            disabled={!canEditStatus || cannotUpdate}
            label="Status"
            name="status"
            component={CustomAutocomplete}
            options={Object.values(TarefaStatusEnum)
              .filter(
                status =>
                  ![
                    TarefaStatusEnum.LIBERADOVIAGEM,
                    TarefaStatusEnum.FINALIZADA
                  ].includes(status)
              )
              .map(status => ({
                label: status,
                value: status
              }))}
          />
        </Grid>
      ) : (
        <Grid item xs={12} sm={3}>
          <Field
            fullWidth
            component={CustomTextField}
            disabled
            label="Status"
            name="status"
          />
        </Grid>
      )}
      <Grid item xs={12} sm={canEdit ? 1 : 3}>
        <Field
          fullWidth
          name="origem"
          label="Origem"
          disabled
          component={CustomTextField}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        {canEdit && (
          <Field
            disabled={cannotUpdate}
            component={Checkbox}
            label="Exclusiva"
            name="exclusiva"
            type="checkbox"
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Informações da Viagem
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          name="ordemCarregamento"
          label="OC/SD"
          disabled={!canEdit || cannotUpdate}
          component={CustomTextField}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          fullWidth
          component={MercadoriaAutocomplete}
          label="Mercadoria"
          name="mercadoriaId"
          needDescription
          showError={showError}
          disabled={!canEdit || cannotUpdate}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={CustomTextField}
          InputProps={{
            inputComponent: NumberFormatCustom
          }}
          label="Valor Carga"
          name="valorCarga"
          showError={showError}
          disabled={!canEdit || cannotUpdate}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          fullWidth
          name="tomador"
          label="Cliente/Tomador"
          component={CustomTextField}
          disabled={!canEdit || cannotUpdate}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          name="previsaoCarregamento"
          label="Previsão de Carregamento"
          component={CustomDateTimePicker}
          disabled={!canEdit || cannotUpdate}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          name="previsaoEntrega"
          label="Previsão de Entrega"
          component={CustomDateTimePicker}
          disabled={!canEdit || cannotUpdate}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              hideEmpty
              component={Select}
              options={estadosOptions}
              label="Estado Origem"
              name="estadoOrigem"
              showError={showError}
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              provinciaId={values.estadoOrigem}
              component={MunicipioAutocomplete}
              label="Cidade Origem"
              name="cidadeOrigem"
              showError={showError}
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              component={CustomTextField}
              format={parseCep}
              label="CEP Origem"
              name="cepOrigem"
              showError={showError}
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="logradouroOrigem"
              label="Logradouro Origem"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="numeroOrigem"
              label="Número Origem"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="complementoOrigem"
              label="Descrição Extra Origem"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              hideEmpty
              component={Select}
              options={estadosOptions}
              label="Estado Destino"
              name="estadoDestino"
              showError={showError}
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              provinciaId={values.estadoDestino}
              component={MunicipioAutocomplete}
              label="Cidade Destino"
              name="cidadeDestino"
              showError={showError}
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              component={CustomTextField}
              format={parseCep}
              label="CEP Destino"
              name="cepDestino"
              showError={showError}
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="logradouroDestino"
              label="Logradouro Destino"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="numeroDestino"
              label="Número Destino"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="complementoDestino"
              label="Descrição Extra Destino"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <EntregasFields
          entregas={values.entregas}
          showError={showError}
          disabled={!canEdit || cannotUpdate}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Motorista
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="CPF"
              parse={parseCpf}
              name="cpfMotorista"
              disabled={!canEdit || cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Nome"
              name="nomeMotorista"
              disabled={!canEdit || cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Telefone"
              parse={parseTelefone}
              name="telefoneMotorista"
              disabled={!canEdit || cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFileViewer
              newTab
              label="CNH"
              filePath={values.cnh}
              fileType="pdf"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Veiculos
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa Cavalo"
              parse={parsePlaca}
              name="placaCavalo"
              disabled={cannotUpdate || !isNew}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa 1"
              parse={parsePlaca}
              name="placa1"
              disabled={cannotUpdate || !isNew}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa 2"
              parse={parsePlaca}
              name="placa2"
              disabled={cannotUpdate || !isNew}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa 3"
              parse={parsePlaca}
              name="placa3"
              disabled={cannotUpdate || !isNew}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={3}>
                <CustomFileViewer
                  newTab
                  label="CRLV Cavalo"
                  filePath={values.crlv}
                  fileType="pdf"
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomFileViewer
                  newTab
                  label="CRLV PLACA 1"
                  filePath={values.crlvPlaca1}
                  fileType="pdf"
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomFileViewer
                  newTab
                  label="CRLV PLACA 2"
                  filePath={values.crlvPlaca2}
                  fileType="pdf"
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomFileViewer
                  newTab
                  label="CRLV PLACA 3"
                  filePath={values.crlvPlaca3}
                  fileType="pdf"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              hideEmpty
              component={CustomSelect}
              options={[
                { label: 'Telemonitoramento', value: 'TELEMONITORAMENTO' },
                { label: 'Localizador', value: 'LOCALIZADOR' },
                { label: 'Rastreador', value: 'RASTREADOR' }
              ]}
              label="Tipo de tecnologia"
              name="tecnologia"
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Field
              fullWidth
              name="marcaTecnologia"
              label="Marca/Modelo"
              disabled={!canEdit || cannotUpdate}
              component={CustomTextField}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="loginRastreador"
              label="Login"
              disabled={
                !canEdit || cannotUpdate || values.tecnologia === 'TELEMONITORAMENTO'
              }
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="senhaRastreador"
              label="Senha"
              disabled={
                !canEdit || cannotUpdate || values.tecnologia === 'TELEMONITORAMENTO'
              }
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="terminal"
              label="ID/Terminal"
              disabled={!canEdit || cannotUpdate || values.tecnologia !== 'RASTREADOR'}
              component={CustomTextField}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={3}>
            <Field
              hideEmpty
              component={CustomSelect}
              options={[
                { label: 'Não', value: false },
                { label: 'Sim', value: true }
              ]}
              label="Isca"
              name="possuiIsca"
              disabled={!canEdit || cannotUpdate}
            />
          </Grid>
          {values.possuiIsca && (
            <>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  name="imei"
                  label="Número/IMEI"
                  disabled={!canEdit || cannotUpdate}
                  component={CustomTextField}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <CustomFileViewer
                  newTab
                  label="Foto da Isca"
                  filePath={values.isca}
                  fileType="pdf"
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Responsável pela frota
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Nome"
              name="nomeResponsavelFrota"
              disabled={!canEdit || cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              parse={parseTelefone}
              label="Telefone"
              name="telefoneResponsavelFrota"
              disabled={!canEdit || cannotUpdate}
              showError={showError}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Monitoramento
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <GerenciadoraField disabled={!canEdit || cannotUpdate} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          fullWidth
          name="identificadorGerenciadora"
          label="Código Identificador"
          disabled={!canEdit || cannotUpdate}
          component={CustomTextField}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Embarcador
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          fullWidth
          component={CentroCustoAutocomplete}
          disabled
          label="Centro Custo"
          name="centroCustoId"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          fullWidth
          component={CustomTextField}
          disabled
          label="Nome"
          name="embarcador.nome"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Field
          fullWidth
          disabled
          name="embarcador.telefone"
          label="Telefone"
          InputLabelProps={{ shrink: true }}
          format={parseTelefone}
          component={CustomTextField}
        />
      </Grid>
      {values.status === TarefaStatusEnum.CANCELADA && (
        <>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Motivo Cancelamento
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              label="Motivo"
              name="motivoCancelamento"
            />
          </Grid>
        </>
      )}
      <ObservacaoField
        value={values.observacao}
        title="Observações"
        placeholder="Escreva aqui observações sobre o monitoramento"
        name="novaObservacao"
        disabled={cannotUpdate}
      />
    </Grid>
  )
}

export default withStyles(styles)(MonitoramentoForm)
